var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('header',{staticClass:"sr-header",attrs:{"role":"banner","aria-label":"Site header"}}),_c('v-main',{attrs:{"tag":"main","role":"main"}},[_c('router-view')],1),_c('footer',{staticClass:"sr-footer",attrs:{"role":"contentinfo","aria-label":"Site footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }